import { useCallback } from 'react';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import I18n from 'I18n';
import formatName from 'I18n/utils/formatName';
import unescapedText from 'I18n/utils/unescapedText';
import { useGrantThreadAccessMutation } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/ThreadAccessGrantRpc.hooks';
import { GET_TICKET_THREAD_KEY } from './useTicketThread';
import { usageTracker } from '../utils/usageTracker';
import { getPortalAccountId, getPortalInstanceId } from 'portals-platform-lib';
export const useGrantThreadAccess = (ticketId, threadId) => {
  const [mutate, {
    loading
  }] = useGrantThreadAccessMutation({
    refetchQueries: [GET_TICKET_THREAD_KEY]
  });
  const grantThreadAccess = useCallback(async contact => {
    const name = formatName({
      name: contact.name,
      email: contact.email
    });
    if (!threadId) {
      return false;
    }
    try {
      await mutate({
        variables: {
          accountId: getPortalAccountId(),
          portalInstanceId: getPortalInstanceId(),
          params: {
            ticketId,
            threadId,
            granteeVid: contact.contactId
          }
        }
      });
    } catch (error) {
      FloatingAlertStore.addAlert({
        message: unescapedText('customer-portal-app.addPeople.failure', {
          name
        }),
        titleText: I18n.text('customer-portal-app.errors.error'),
        type: 'danger'
      });
      return false;
    }
    usageTracker.track('Customer Portal App', 'Threads Manipulated', {
      action: 'people-added',
      screen: 'ticket-details'
    });
    FloatingAlertStore.addAlert({
      message: unescapedText('customer-portal-app.addPeople.success', {
        name
      }),
      type: 'success'
    });
    return true;
  }, [mutate, ticketId, threadId]);
  return {
    grantThreadAccess,
    isGranting: loading
  };
};